import React from "react";
import DefaultImage from "./images/Marker.png";
import Style from "../../styles/js/Styles";
import { Marker } from 'react-leaflet'
import L from 'leaflet';

const ReportMarker = (props: any) => {
  const style = Style();

  return (
  	<Marker className={style.marker}
      position={[props.lat,props.lng]}
      icon={new L.Icon({ 
        iconUrl: DefaultImage,
        iconSize: [45,45],
        iconAnchor: new L.Point(22.5, 45),
      })}
    />
  );
};

export default ReportMarker;
